module.exports = __webpack_public_path__ + "static/media/app02_ch02.233e6a0b.png";